<div class="html-editor" [class.html-editor-disabled]="disabled">
  <div class="html-editor-toolbar">
    <button mat-icon-button type="button" (click)="exec('bold')" [disabled]="disabled" title="Bold">
      <mat-icon>format_bold</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('italic')" [disabled]="disabled" title="Italic">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('underline')" [disabled]="disabled" title="Underline">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('strikeThrough')" [disabled]="disabled" title="Strikethrough">
      <mat-icon>strikethrough_s</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('insertUnorderedList')" [disabled]="disabled" title="Bullet list">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('insertOrderedList')" [disabled]="disabled" title="Numbered list">
      <mat-icon>format_list_numbered</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="toggleBlockquote()" [disabled]="disabled" title="Quote">
      <mat-icon>format_quote</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="addLink()" [disabled]="disabled" title="Insert link">
      <mat-icon>link</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('unlink')" [disabled]="disabled" title="Remove link">
      <mat-icon>link_off</mat-icon>
    </button>
    <button mat-icon-button type="button" (click)="exec('removeFormat')" [disabled]="disabled" title="Clear formatting">
      <mat-icon>format_clear</mat-icon>
    </button>
  </div>
  <div #editor class="html-editor-content" [attr.contenteditable]="disabled ? 'false' : 'true'"
    (input)="onInput()" (paste)="onPaste($event)" (blur)="markTouched()"></div>
</div>
